import { jwtDecode, JwtPayload } from 'jwt-decode';

export const isRtpTokenExpired = (rtpToken: string): boolean => {
  if (!rtpToken) {
    return true;
  }
  const decodedToken = jwtDecode<JwtPayload>(rtpToken);
  return decodedToken?.exp === undefined || Math.floor(Date.now() / 1000) >= decodedToken?.exp;
};
